module.exports = __webpack_public_path__ + "img/quo-pay.fbf9888f.png";